export default [
  {
    path: '/report/backToSchoolStatistics',
    component: resolve => require(['@/pages/report/backToSchoolStatistics.vue'], resolve),
    name: 'backToSchoolStatistics',
    meta: {
      title: '学生返校统计'
    }
  },
  {
    path: '/report/repair',
    component: resolve => require(['@/pages/report/repair.vue'], resolve),
    name: 'repairRoport',
    meta: {
      title: '报修统计'
    }
  },
  {
    path: '/report/goodGraduate',
    component: resolve => require(['@/pages/report/goodGraduate.vue'], resolve),
    name: 'goodGraduate',
    meta: {
      title: '优秀毕业生'
    }
  },
  {
    path: '/report/scholarship',
    component: resolve => require(['@/pages/report/scholarship.vue'], resolve),
    name: 'scholarship',
    meta: {
      title: '奖学金'
    }
  },
  {
    path: '/report/titleOfHonor',
    component: resolve => require(['@/pages/report/titleOfHonor.vue'], resolve),
    name: 'titleOfHonor',
    meta: {
      title: '荣誉称号'
    }
  },
  {
    path: '/report/collectiveTitleOfHonor',
    component: resolve => require(['@/pages/report/collectiveTitleOfHonor.vue'], resolve),
    name: 'collectiveTitleOfHonor',
    meta: {
      title: '集体荣誉称号'
    }
  },
  {
    path: '/report/loveTicket',
    component: resolve => require(['@/pages/report/loveTicket.vue'], resolve),
    name: 'loveTicket',
    meta: {
      title: '爱心车票'
    }
  },
  {
    path: '/report/enlistInTheArmy',
    component: resolve => require(['@/pages/report/enlistInTheArmyV.vue'], resolve),
    name: 'enlistInTheArmy',
    meta: {
      title: '征兵入伍'
    }
  },
  {
    path: '/report/leaveSchoolChart',
    component: resolve => require(['@/pages/report/leaveSchoolChart.vue'], resolve),
    name: 'leaveSchoolChart',
    meta: {
      title: '请假申请'
    }
  },
  {
    path: '/report/studentManagement',
    component: resolve => require(['@/pages/report/studentManagement.vue'], resolve),
    name: 'leaveSchoolChart',
    meta: {
      title: '学生管理'
    }
  },
  {
    path: '/report/backSchoolChart',
    component: resolve => require(['@/pages/report/backSchoolChart.vue'], resolve),
    name: 'backSchoolChart',
    meta: {
      title: '续假申请申请'
    }
  },
  {
    path: '/report/fileManagementChart',
    component: resolve => require(['@/pages/report/fileManagementChart.vue'], resolve),
    name: 'fileManagementChart',
    meta: {
      title: '辅导员档案管理'
    }
  },
  {
    path: '/report/graduateManagement',
    component: resolve => require(['@/pages/report/graduateManagement.vue'], resolve),
    name: 'graduateManagement',
    meta: {
      title: '毕业生档案管理'
    }
  },
  {
    path: '/report/counselorAssessment',
    component: resolve => require(['@/pages/report/counselorAssessment.vue'], resolve),
    name: 'counselorAssessment',
    meta: {
      title: '辅导员测评'
    }
  },
  {
    path: '/report/psychologicalAppointmentsChart',
    component: resolve => require(['@/pages/report/psychologicalAppointmentsChart.vue'], resolve),
    name: 'psychologicalAppointmentsChart',
    meta: {
      title: '心理预约'
    }
  },
  {
    path: '/report/officeApprovalChart',
    component: resolve => require(['@/pages/report/officeApprovalChart.vue'], resolve),
    name: 'officeApprovalChart',
    meta: {
      title: '办公审批统计'
    }
  },
  {
    path: '/report/welcomeNewStudents',
    component: resolve => require(['@/pages/report/welcomeNewStudents.vue'], resolve),
    name: 'officeApprovalChart',
    meta: {
      title: '迎新统计'
    }
  },
  {
    path: '/report/dataAcquisition',
    component: resolve => require(['@/pages/report/dataAcquisition.vue'], resolve),
    name: 'officeApprovalChart',
    meta: {
      title: '新生数据采集'
    }
  },
  {
    path: '/report/dayReading',
    component: resolve => require(['@/pages/report/dayReading.vue'], resolve),
    name: 'officeApprovalChart',
    meta: {
      title: '校外生走读'
    }
  },
  {
    path: '/report/questionnaireInvestigation',
    component: resolve => require(['@/pages/report/questionnaireInvestigation.vue'], resolve),
    name: 'questionnaireInvestigation',
    meta: {
      title: '问卷调查统计'
    }
  },
  {
    path: '/report/vaccinationStatistics',
    component: resolve => require(['@/pages/report/vaccinationStatistics.vue'], resolve),
    name: 'vaccinationStatistics',
    meta: {
      title: '疫苗接种统计'
    }
  },
  {
    path: '/report/dormInfo',
    component: resolve => require(['@/pages/report/dormInfo.vue'], resolve),
    name: 'vaccinationStatistics',
    meta: {
      title: '宿舍信息统计'
    }
  },
] 


// WEBPACK FOOTER //
// ./src/router/modules/report.js